export function refineCourse( rawCourse ) {
    if ( !rawCourse ) { return undefined; }

    return {
        enrollment: !rawCourse?.enrollment ? undefined : {
            ...rawCourse?.enrollment,
            percentComplete: rawCourse?.enrollment
                ? ( rawCourse?.enrollment / 100 )
                : 0.0, // [0.0 - 1.0]
        },
        ...rawCourse?.node,
        learningObjects: rawCourse?.node?.learningObjects?.edges.map( learningObject => ( {
            assignment: learningObject.assignment,
            ...learningObject.node,
        } ) ),
        lxp: {
            relatedResourceBrandIds: rawCourse.node.brandIds,
            relatedResourceLocaleIds: rawCourse.node.localeIds,
            relatedResourceCompanyRelationshipIds: rawCourse.node.companyRelationshipIds,
            relatedResourceProductIds: rawCourse.node.productIds,
        }
    };
}
